<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script lang="ts" setup>
  
</script>
